import { ILiveStreamOptions } from 'fitbeat.models';
import moment from 'moment-timezone';
import React from 'react';
import { FunctionComponent } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { BulletPoint } from '../../Influencer/InfluencerLearnMorePartOne';
import Theme from '../../theme';
import { defaultScale } from '../../utils';

interface IProps {
  livestreamOptions?: ILiveStreamOptions;
  displayedAtStartOfWorkout?: boolean;
  startTimeOfFirstExercise: Date;
  t(key: string, options?: { [key: string]: string }): string;
}

export const LivestreamOptionsSummary: FunctionComponent<IProps> = (
  {
    livestreamOptions,
    displayedAtStartOfWorkout = false,
    startTimeOfFirstExercise,
    t,
  }) => {
  const warmupStartTime = moment.tz(startTimeOfFirstExercise, moment.tz.guess()).add(5, 'minutes').format('HH:mm');
  return (
    <View>
      <Text style={[Theme.textStyle.heading2, { marginBottom: defaultScale(18) }]}>
        {t(displayedAtStartOfWorkout
          ? 'livestreamOptionsSummaryHeadingInWorkoutStart'
          : 'livestreamOptionsSummaryHeadingInBooking')}
      </Text>

      <BulletPoint>
        <Text style={styles.text}>
          {t(displayedAtStartOfWorkout
            ? 'livestreamOptionsSummaryPoint1InWorkoutStart'
            : 'livestreamOptionsSummaryPoint1InBooking')}
        </Text>
      </BulletPoint>
      <BulletPoint>
        <Text style={styles.text}>
          {t('livestreamOptionsSummaryPoint2')}
        </Text>
      </BulletPoint>

      {livestreamOptions?.preWorkoutTalk &&
        <BulletPoint>
          <Text style={styles.text}>
            {t('livestreamOptionsSummaryPoint3', { warmupStartTime })}
            {livestreamOptions?.preWorkoutTalkTopic && `${t('talkTopic')}${livestreamOptions.preWorkoutTalkTopic}`}
          </Text>
        </BulletPoint>
      }

      <BulletPoint>
        <Text style={styles.text}>
          {t(livestreamOptions?.streamerWillDropOffAfterTalk
            ? 'livestreamOptionsSummaryPoint4IfLeavingAfterTalk'
            : 'livestreamOptionsSummaryPoint4IfStayingAfterTalk')}
        </Text>
      </BulletPoint>
    </View>
  );
};

const styles = StyleSheet.create({
  text: {
    ...Theme.textStyle.bodyCopyReg,
  },
});
